import React, { createContext, useContext, useEffect, useState } from 'react'

type Tema = 'light' | 'dark'

interface ContextoTemaType {
  tema: Tema
  toggleTema: () => void
  resetTema: () => void
  isDark: boolean
}

const ContextoTema = createContext<ContextoTemaType | undefined>(undefined)

interface ProveedorTemaProps {
  children: React.ReactNode
}

export const ProveedorTema: React.FC<ProveedorTemaProps> = ({ children }) => {
  const [tema, setTema] = useState<Tema>(() => {
    try {
      const temaGuardado = localStorage.getItem('logixport-tema') as Tema | null
      if (temaGuardado === 'dark' || temaGuardado === 'light') {
        return temaGuardado
      }
    } catch (e) {
      console.warn('Error al leer localStorage:', e)
    }
    return 'light'
  })

  // Efecto para sincronizar cambios y actualizar HTML
  useEffect(() => {
    localStorage.setItem('logixport-tema', tema)
    const root = document.documentElement
    root.classList.toggle('dark', tema === 'dark')
    
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', tema === 'dark' ? '#1f2937' : '#ffffff')
    }
  }, [tema])

  const toggleTema = () => {
    const nuevoTema = tema === 'light' ? 'dark' : 'light'
    setTema(nuevoTema)
    localStorage.setItem('logixport-tema', nuevoTema)
  }

  const resetTema = () => {
    localStorage.removeItem('logixport-tema')
    setTema('light')
  }

  const value: ContextoTemaType = {
    tema,
    toggleTema,
    resetTema,
    isDark: tema === 'dark'
  }

  return (
    <ContextoTema.Provider value={value}>
      {children}
    </ContextoTema.Provider>
  )
}

export const useTema = (): ContextoTemaType => {
  const context = useContext(ContextoTema)
  if (context === undefined) {
    throw new Error('useTema debe ser usado dentro de un ProveedorTema')
  }
  return context
}

export default ContextoTema